import '.aq{position:relative;}.ssr-plugin'
import '.lf{width:64px;}.ssr-plugin'
import '.lg{height:64px;}.ssr-plugin'
import '.bc{flex-shrink:0;}.ssr-plugin'
import '.az{position:absolute;}.ssr-plugin'
import '.lh{bottom:-4px;}.ssr-plugin'
import '.j9{right:-4px;}.ssr-plugin'
import '.h0{border-radius:50%;}.ssr-plugin'
import '.ck{border:2px solid var(--palette-white);}.ssr-plugin'
import '.bt{overflow:hidden;}.ssr-plugin'
import '.li{width:32px;}.ssr-plugin'
import '.lj{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="aq lf lg bc"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="az lh j9 h0 ck bt li lj"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
